import React from 'react';
import TooltipsMLStyled from './TooltipsMLStyled';
import { Tooltip } from '@material-ui/core';
import ErrorOutlineOutlinedIcon from '@material-ui/icons/ErrorOutlineOutlined';
import ErrorOutlinedIcon from '@material-ui/icons/ErrorOutlined';

const TooltipsML = (props) => {
  return (
    <TooltipsMLStyled
      isAbsolute={props.isAbsolute}
      top={props.top}
      left={props.left}
      right={props.right}
      color={props.color}
    >
      <Tooltip
        title={<span style={{ fontSize: 14 }}>{props.title}</span>}
        arrow
      >
        {props?.isFilled ? (
          <ErrorOutlinedIcon className="title-icon" />
        ) : (
          <ErrorOutlineOutlinedIcon className="title-icon" />
        )}
      </Tooltip>
    </TooltipsMLStyled>
  );
};
export default TooltipsML;
